import { TAKAFUL_PROVIDER_LANGUAGE } from "./takafulProvider";
import { SERVICE_PROVIDER_LANGUAGE } from "./serviceProvider";
import { AUTH_LANGUAGE } from "./auth";
import { MANAGEMENT_LANGUAGE } from "./management";
import { MENU_LANGUAGE } from "./menu";
import { COMMON } from "./common";
import { LEADS_LANGUAGE } from "./leads";
import { COUPONS_LANGUAGE } from "./coupons";
import { FAQ } from "./faq";
import { HEALTH_LANGUAGE } from "./health";
import { AUTO_LANGUAGE } from "./auto";
import { PARTNER_LANGUAGE } from "./partner";
import { BAC_LANGUAGE } from "./bac";
import { personalAccident_LANGUAGE } from "./personalAccident";
import { houseHold_LANGUAGE } from "./houseHold";
import { life_LANGUAGE } from "./life";

export const Lang = {
  ...TAKAFUL_PROVIDER_LANGUAGE,
  ...SERVICE_PROVIDER_LANGUAGE,
  ...AUTH_LANGUAGE,
  ...MANAGEMENT_LANGUAGE,
  ...MENU_LANGUAGE,
  ...COMMON,
  ...LEADS_LANGUAGE,
  ...COUPONS_LANGUAGE,
  ...FAQ,
  ...HEALTH_LANGUAGE,
  ...AUTO_LANGUAGE,
  ...PARTNER_LANGUAGE,
  ...BAC_LANGUAGE,
  ...personalAccident_LANGUAGE,
  ...houseHold_LANGUAGE,
  ...life_LANGUAGE
};
